import { type RefObject, useEffect } from "react";

export function useOutsideClick(
  ref: RefObject<HTMLElement>,
  onOutsideClick: () => void,
) {
  const handleOutsideClick = (evt: globalThis.MouseEvent) => {
    if (ref.current && !evt.composedPath().includes(ref.current)) {
      onOutsideClick();
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: handleOutsideClick is a caller-supplied callback, normally an inline arrow, so listing it would detach and re-attach the document listener on every render. The listener is intentionally attached once for the lifetime of the hook.
  useEffect(() => {
    document.addEventListener("click", handleOutsideClick, false);

    return () => {
      document.removeEventListener("click", handleOutsideClick, false);
    };
  }, []);
}
